import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import '../styles.less'
import { getManageBankAccount } from '../../../redux/actions/manageBankAccount'
import ViewFileseFillingWidget from '../../../widgets/eFillingListFormWidgets/ViewFileseFillingWidget'

export default function ViewFileseFilling() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionStorage.getItem('projectCode')

  useEffect(() => {
    handleGetSchema(projectCode)
  }, [])

  const handleGetSchema = async (projectCode) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getManageBankAccount(projectCode)
      // setSchema(response.model)
      setSchema(mockSchema.model)
      console.log('mockSchema==>', schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      {/* <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi /> */}
      {/* isShowGoButton //ย้อนหลัง */}

      <ViewFileseFillingWidget schema={schema} dataList={schema.fileseFillingValues} />

      <br />
      {/* </SidebarProposal> */}
    </div>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: null,
  didError: false,
  errorMessage: null,
  model: {
    header: '',
    subHeader: '',
    disabled: false,

    fileseFillingValues: [
      {
        id: '9F262C5E-6870-122E-ADBA-172E3DC1903A',
        taxNo: '1120500057645',
        prefix: 'นางสาว',
        fullName: 'พเยาว์ ผ่อนสุข',
        buildingName: '',
        villageName: '',
        roomNumber: '',
        floor: '',
        localVillageName: '',
        houseNumber: '695',
        villageNumber: '',
        lane: 'ซ.จรัญสนิทวงศ์ 12',
        crossroads: '',
        road: 'ถ.จรัญสนิทวงศ์',
        subDistrict: 'แขวงวัดท่าพระ',
        district: 'เขตบางกอกใหญ่',
        province: 'จ.กรุงเทพมหานคร',
        postalCode: '10600',
        datePayment: '2023/09/22',
        typePayment: '1% ค่าตอบแทน',
        taxRate: '1',
        withholding: 237000,
        withholdingTotal: 2370,
        condition: '1',
        payment: 3800020256,
        year: '2023',
      },
      {
        id: '1F262C5E-6870-122E-ADBA-172E3DC1903A',
        taxNo: '3409900638531',
        prefix: 'นางสาว',
        fullName: 'ดวงพร เฮงบุณยพันธ์',
        buildingName: '',
        villageName: '',
        roomNumber: '',
        floor: '',
        localVillageName: '',
        houseNumber: '88/112',
        villageNumber: '',
        lane: '',
        crossroads: '',
        road: '',
        subDistrict: 'ต.คลองห้า',
        district: 'อ.คลองหลวง',
        province: 'จ.ปทุมธานี',
        postalCode: '12110',
        datePayment: '2023/09/22',
        typePayment: '1% ค่าตอบแทน',
        taxRate: '1',
        withholding: 122521.25,
        withholdingTotal: 1225.21,
        condition: '1',
        payment: 3800020257,
        year: '2023',
      },
      {
        id: '8F262C5E-6870-122E-ADBA-172E3DC1903A',
        taxNo: '3570700305076',
        prefix: 'นาย',
        fullName: 'ธานินทร์ สุวงศ์วาร',
        buildingName: '',
        villageName: '',
        roomNumber: '',
        floor: '',
        localVillageName: '',
        houseNumber: '12',
        villageNumber: '',
        lane: '',
        crossroads: '',
        road: 'ถ.เทศบาลนฤมาล',
        subDistrict: 'แขวงลาดยาว',
        district: 'เขตจตุจักร',
        province: 'จ.กรุงเทพมหานคร',
        postalCode: '10900',
        datePayment: '2023/09/01',
        typePayment: '1% ค่าตอบแทน',
        taxRate: '1',
        withholding: 813084.11,
        withholdingTotal: 8130.84,
        condition: '1',
        payment: 3800018897,
        year: '2023',
      },
      {
        id: '6F262C5E-6870-122E-ADBA-172E3DC1903A',
        taxNo: '3100602280960',
        prefix: 'นาย',
        fullName: 'วิชญ์พิพล ติวะตันสกุล',
        buildingName: '',
        villageName: '',
        roomNumber: '',
        floor: '',
        localVillageName: '',
        houseNumber: '12',
        villageNumber: '',
        lane: '',
        crossroads: '',
        road: 'ถ.เทศบาลนฤมาล',
        subDistrict: 'แขวงลาดยาว',
        district: 'เขตจตุจักร',
        province: 'จ.กรุงเทพมหานคร',
        postalCode: '10900',
        datePayment: '2023/09/01',
        typePayment: '1% ค่าตอบแทน',
        taxRate: '1',
        withholding: 8373831.76,
        withholdingTotal: 3738.32,
        condition: '1',
        payment: 3800018898,
        year: '2023',
      },
    ],
  },
}
